import { jsx as C } from "react/jsx-runtime";
const e = ({
  size: r
}) => {
  switch (r) {
    case "sm":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M1.245 13.8317L8.00133 2.16504L14.7577 13.8317H1.245ZM8.00133 12.0369C8.15388 12.0369 8.28177 11.9853 8.385 11.882C8.48822 11.7788 8.53983 11.6509 8.53983 11.4984C8.53983 11.3458 8.48822 11.2179 8.385 11.1147C8.28177 11.0115 8.15388 10.9599 8.00133 10.9599C7.84877 10.9599 7.72088 11.0115 7.61766 11.1147C7.51444 11.2179 7.46283 11.3458 7.46283 11.4984C7.46283 11.6509 7.51444 11.7788 7.61766 11.882C7.72088 11.9853 7.84877 12.0369 8.00133 12.0369ZM7.50133 10.2932H8.50133V6.95987H7.50133V10.2932Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M1.86499 20.75L11.9995 3.25L22.134 20.75H1.86499ZM11.9995 18.0577C12.2283 18.0577 12.4202 17.9803 12.575 17.8255C12.7298 17.6707 12.8072 17.4788 12.8072 17.25C12.8072 17.0212 12.7298 16.8293 12.575 16.6745C12.4202 16.5197 12.2283 16.4423 11.9995 16.4423C11.7707 16.4423 11.5788 16.5197 11.424 16.6745C11.2692 16.8293 11.1917 17.0212 11.1917 17.25C11.1917 17.4788 11.2692 17.6707 11.424 17.8255C11.5788 17.9803 11.7707 18.0577 11.9995 18.0577ZM11.2495 15.4423H12.7495V10.4423H11.2495V15.4423Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M1.55499 17.2933L10.0004 2.70996L18.4458 17.2933H1.55499ZM10.0004 15.0498C10.1911 15.0498 10.351 14.9852 10.48 14.8562C10.609 14.7272 10.6735 14.5673 10.6735 14.3766C10.6735 14.1859 10.609 14.0261 10.48 13.897C10.351 13.768 10.1911 13.7035 10.0004 13.7035C9.80972 13.7035 9.64985 13.768 9.52083 13.897C9.3918 14.0261 9.32729 14.1859 9.32729 14.3766C9.32729 14.5673 9.3918 14.7272 9.52083 14.8562C9.64985 14.9852 9.80972 15.0498 10.0004 15.0498ZM9.37541 12.8702H10.6254V8.7035H9.37541V12.8702Z",
          fill: "currentColor"
        }
      );
  }
}, n = ({
  size: r
}) => {
  switch (r) {
    case "sm":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M0.549988 14.4349L7.99882 1.56494L15.4477 14.4349H0.549988ZM7.99882 12.3551C8.19038 12.3551 8.35271 12.2886 8.48582 12.1554C8.61893 12.0224 8.68549 11.8602 8.68549 11.6686C8.68549 11.4771 8.61893 11.3154 8.48582 11.1836C8.35271 11.0518 8.19038 10.9859 7.99882 10.9859C7.80727 10.9859 7.64493 11.0518 7.51182 11.1836C7.37871 11.3154 7.31215 11.4771 7.31215 11.6686C7.31215 11.8602 7.37871 12.0224 7.51182 12.1554C7.64493 12.2886 7.80727 12.3551 7.99882 12.3551ZM7.33215 10.3671H8.66549V7.07761H7.33215V10.3671Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M0.825012 21.65L11.9983 2.34497L23.1715 21.65H0.825012ZM11.9983 18.5302C12.2856 18.5302 12.5291 18.4304 12.7288 18.2307C12.9284 18.0312 13.0283 17.7878 13.0283 17.5005C13.0283 17.2131 12.9284 16.9706 12.7288 16.773C12.5291 16.5753 12.2856 16.4765 11.9983 16.4765C11.7109 16.4765 11.4674 16.5753 11.2678 16.773C11.0681 16.9706 10.9683 17.2131 10.9683 17.5005C10.9683 17.7878 11.0681 18.0312 11.2678 18.2307C11.4674 18.4304 11.7109 18.5302 11.9983 18.5302ZM10.9983 15.5482H12.9983V10.614H10.9983V15.5482Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ C(
        "path",
        {
          d: "M0.690002 18.0426L10.001 1.95508L19.3121 18.0426H0.690002ZM10.001 15.4428C10.2405 15.4428 10.4434 15.3596 10.6098 15.1932C10.7762 15.027 10.8594 14.8241 10.8594 14.5847C10.8594 14.3452 10.7762 14.1431 10.6098 13.9784C10.4434 13.8137 10.2405 13.7313 10.001 13.7313C9.7616 13.7313 9.55868 13.8137 9.39229 13.9784C9.22591 14.1431 9.14271 14.3452 9.14271 14.5847C9.14271 14.8241 9.22591 15.027 9.39229 15.1932C9.55868 15.3596 9.7616 15.4428 10.001 15.4428ZM9.16771 12.9578H10.8344V8.84591H9.16771V12.9578Z",
          fill: "currentColor"
        }
      );
  }
}, o = ({
  size: r = "md",
  weight: t = "default"
}) => {
  switch (t) {
    case "bold":
      return /* @__PURE__ */ C(n, { size: r });
    case "book":
    case "default":
      return /* @__PURE__ */ C(e, { size: r });
  }
};
export {
  o as default
};
//# sourceMappingURL=DIconWarningInverted.js.map
